// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__SzeNb","right":"styles_right__tWw28"};